import React from 'react';
import PropTypes from 'prop-types';
//import styled from 'styled-components';

import {Row, Col, Card, Collapse} from 'reactstrap';

import '../html/fontawesome/css/all.min.css';

import MagstimAccordion from "./MagstimAccordion"
import MagstimPropertyCard from './MagstimPropertyCard';

import * as StringUtils from '../utils/StringUtils.js'

import {isPDA} from 'common'


class PatientTreatmentPlan extends React.Component {

    constructor() {
        super();

        this.state = {
            isOpen: false
        };
    }

    getNamedValuePairs(data) {
        return [
            { name: '%rMT', value: StringUtils.formatPercent(data.pcRMT) },
            { name: 'Hz (PPS)', value: data.pps },
            { name: 'Pulses', value: data.pulses },
            { name: 'Duration', value: StringUtils.formatMinuteAndSeconds(data.duration) },
            { name: 'Mode', value: data.mode }
        ];
    }

    toggleOnClick = (event) => {
        // set internal state of accordion/chevron
        let openState = !this.state.isOpen;
        this.setState({
			isOpen: openState
        });

        if(this.props.toggleOnClick){
            this.props.toggleOnClick(this.props.eventKey);
        }
    }

    render() {

        var pairs = this.getNamedValuePairs(this.props.data);

        // console.log('PatientTreatmentPlan.render pairs=' + JSON.stringify(pairs));
        // console.log('PatientTreatmentPlan.render props=' + JSON.stringify(this.props.data));
        // console.log('PatientTreatmentPlan.render stimguideLocations=' + JSON.stringify(this.props.stimguideLocations));

        return (
            <Row>
                <Col>
                    <Card>
                        <MagstimAccordion
                            smallLayout={isPDA()}
                            title={this.props.data.name}
                            toggleOnClick={this.toggleOnClick}
                        />
                        <Collapse isOpen={this.state.isOpen} className="ui-card" >
                            <MagstimPropertyCard title={this.props.data.name} listitems={pairs} />
                        </Collapse>
                    </Card>
                </Col>
            </Row>
        );
    }
}

PatientTreatmentPlan.propTypes = {
    index: PropTypes.number,
    data: PropTypes.object
};

PatientTreatmentPlan.defaultProps = {
    index: undefined,
    data: undefined
};

export default PatientTreatmentPlan;